import React, { ReactElement } from 'react';
import classNames from 'classnames';

import './stars.scss';

export interface StarsProps {
    inline?: boolean;
    className?: string;
    width: number;
    size?: 'sm' | 'md' | 'lg';
}

const Stars: React.FC<StarsProps> = ({ className, width, inline, size = 'sm' }): ReactElement => (
    <div
        className={classNames({
            'star-rating': true,
            [`${className}`]: !!className,
            'star-rating--inline': !!inline,
            [`star-rating-${size}`]: true
        })}
    >
        <span style={{ width: `${width * 20}%` }}/>
    </div>
);

export default Stars;
